import { lazy, Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./pages/Navbar/Navbar";
import Footer from "./sections/Footer/Footer";
import ModalForm from "./pages/Contact/ModalForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css"
// Lazy loaded pages
const Home = lazy(() => import("./pages/Home/Home"));

// const AboutPage = lazy(() =>
//   import("./navigations/About/Aboutpage/Aboutpage")
// );
const VisionPage = lazy(() =>
  import("./navigations/About/VisionPage/VisionPage")
);
const MissionPage = lazy(() =>
  import("./navigations/About/MissionPage/MissionPage")
);
const PurposePage = lazy(() =>
  import("./navigations/About/PurposePage/PurposePage")
);
const ValuePropositionPage = lazy(() =>
  import("./navigations/About/ValuePropositionPage/ValuePropositionPage")
);
const LeadershipPage = lazy(() =>
  import("./navigations/About/LeadershipPage/LeadershipPage")
);

// const ServicesPage = lazy(() =>
//   import("./navigations/Services/ServicesPage/ServicesPage")
// );
const AIAdvisory = lazy(() =>
  import("./navigations/Services/AIAdvisory/AIAdvisory")
);
const DigitalAdvisory = lazy(() =>
  import("./navigations/Services/DigitalAdvisory/DigitalAdvisory")
);
const DataAdvisory = lazy(() =>
  import("./navigations/Services/DataAdvisory/DataAdvisory")
);
const ITAdvisory = lazy(() =>
  import("./navigations/Services/ITAdvisory/ITAdvisory")
);
const GCCAdvisory = lazy(() =>
  import("./navigations/Services/GCCAdvisory/GCCAdvisory")
);

// const Opportunities = lazy(() =>
//   import("./navigations/Opportunities/Opportunities")
// );
const AdvisoryPartnerForm = lazy(() =>
  import("./navigations/Opportunities/AdvisoryPartnerForm/AdvisoryPartnerForm")
);
const DeliveryPartnerForm = lazy(() =>
  import("./navigations/Opportunities/DeliveryPartnerForm/DeliveryPartnerForm")
);
const BusinessPartnerForm = lazy(() =>
  import("./navigations/Opportunities/BusinessPartnerForm/BusinessPartnerForm")
);
const EmployeePartnerForm = lazy(() =>
  import("./navigations/Opportunities/EmployeePartnerForm/EmployeePartnerForm")
);

// const Insights = lazy(() =>
//   import("./navigations/Insights/Insights")
// );
const Blogs = lazy(() =>
  import("./navigations/Insights/Blogs/Blogs")
);
const Whitepapers = lazy(() =>
  import("./navigations/Insights/Whitepapers/Whitepapers")
);
const CaseStudies = lazy(() =>
  import("./navigations/Insights/CaseStudies/CaseStudies")
);

// const Solutions = lazy(() =>
//   import("./navigations/Solutions/Solutions")
// );
const AIReadiness = lazy(() =>
  import("./navigations/Solutions/AIReadiness")
);
const TechnologyAssessment = lazy(() =>
  import("./navigations/Solutions/TechnologyAssessment")
);
const OperatingModel = lazy(() =>
  import("./navigations/Solutions/OperatingModel")
);
const ProcessOptimization = lazy(() =>
  import("./navigations/Solutions/ProcessOptimization")
);
const DigitalTransformation = lazy(() =>
  import("./navigations/Solutions/DigitalTransformation")
);

const GlobalReach = lazy(() =>
  import("./navigations/Globle/GlobalReach")
);

const SevenRMethodology = lazy(() =>
  import("./sections/SevenRMethodology/SevenRMethodology")
);

const Admin = lazy(() =>
  import("./Admin/AdminPage/Admin")
);



import AboutPage from "./navigations/About/Aboutpage/Aboutpage";
import ServicesPage from "./navigations/Services/ServicesPage/ServicesPage";
import Opportunities from "./navigations/Opportunities/Opportunities";
import Insights from "./navigations/Insights/Insights";
import Solutions from "./navigations/Solutions/Solutions";
import NotFound from "./sections/NotFound";

function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      Loading...
    </div>
  );
}

const App = () => {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Navbar />}

      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ModalForm />} />
          <Route path="/global-reach" element={<GlobalReach />} />
          <Route path="/sevenR" element={<SevenRMethodology />} />

          <Route path="/about" element={<AboutPage />}>
            <Route index element={<Navigate to="vision" replace />} />
            <Route path="vision" element={<VisionPage />} />
            <Route path="mission" element={<MissionPage />} />
            <Route path="purpose" element={<PurposePage />} />
            <Route
              path="value-proposition"
              element={<ValuePropositionPage />}
            />
            <Route path="leadership" element={<LeadershipPage />} />
          </Route>

          <Route path="/approach" element={<ServicesPage />}>
            <Route index element={<Navigate to="ai-strategy" replace />} />
            <Route path="ai-strategy" element={<AIAdvisory />} />
            <Route
              path="digital-transformation"
              element={<DigitalAdvisory />}
            />
            <Route path="data-strategy" element={<DataAdvisory />} />
            <Route path="it-operations" element={<ITAdvisory />} />
            <Route path="gcc-advisory" element={<GCCAdvisory />} />
          </Route>

          <Route path="/insights" element={<Opportunities />}>
            <Route
              index
              element={<Navigate to="advisory-partner" replace />}
            />
            <Route
              path="advisory-partner"
              element={<AdvisoryPartnerForm />}
            />
            <Route
              path="delivery-partner"
              element={<DeliveryPartnerForm />}
            />
            <Route
              path="business-partner"
              element={<BusinessPartnerForm />}
            />
            <Route
              path="employee-partner"
              element={<EmployeePartnerForm />}
            />
          </Route>

          <Route path="/thinking" element={<Insights />}>
            <Route index element={<Navigate to="blogs" replace />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="whitepapers" element={<Whitepapers />} />
            <Route path="case-studies" element={<CaseStudies />} />
          </Route>

          <Route path="/impact" element={<Solutions />}>
            <Route index element={<Navigate to="ai-readiness" replace />} />
            <Route path="ai-readiness" element={<AIReadiness />} />
            <Route
              path="technology-assessment"
              element={<TechnologyAssessment />}
            />
            <Route
              path="operating-model"
              element={<OperatingModel />}
            />
            <Route
              path="process-optimization"
              element={<ProcessOptimization />}
            />
            <Route
              path="dt-roadmap"
              element={<DigitalTransformation />}
            />
          </Route>

          <Route path="/admin/*" element={<Admin />} />
                <Route path="*" element={<NotFound />} />

        </Routes>
      </Suspense>
      {!isAdminRoute && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default App;